const billing = {
  pageTitle: 'المدفوعات والفواتير',
  pageDescription: 'سجل مدفوعاتك وفواتيرك الضريبية - اعرض أو نزّل أو اطبع أي فاتورة.',
  backToAccount: 'العودة إلى الحساب',

  invoices: {
    title: 'الفواتير',
    description: 'كل عملية شراء تُنشئ فاتورة ضريبية واحدة مفصّلة (ضريبة القيمة المضافة 15%).',
    invoice: 'الفاتورة',
    date: 'التاريخ',
    items: 'البنود',
    total: 'الإجمالي',
    status: 'الحالة',
    actions: 'إجراءات',
    view: 'عرض',
    download: 'PDF',
    moreItems: '+{{count}} أخرى',
    empty: 'لا توجد فواتير بعد',
    emptyDescription: 'بمجرد اشتراكك أو شرائك إضافة، ستظهر فواتيرك هنا.',
    loadError: 'تعذّر تحميل فواتيرك.',
    retry: 'إعادة المحاولة',
    pdfFallback: 'تم فتح نسخة قابلة للطباعة - استخدم المتصفح لحفظها بصيغة PDF.',
    pdfError: 'تعذّر فتح الفاتورة.',
    page: 'صفحة {{page}} من {{total}}',
    prev: 'السابق',
    next: 'التالي',
  },

  status: {
    ISSUED: 'صادرة',
    PAID: 'مدفوعة',
    REFUNDED: 'مستردة',
    PARTIALLY_REFUNDED: 'مستردة جزئياً',
    CANCELLED: 'ملغاة',
  },

  subscription: {
    title: 'الاشتراك',
    plan: 'الباقة',
    status: 'الحالة',
    nextRenewal: 'التجديد القادم',
    autoRenew: 'التجديد التلقائي',
    autoRenewPending: 'يبدأ التجديد التلقائي بمجرد تفعيل الدفع بالبطاقة المحفوظة. حالياً جدّد يدوياً قبل التاريخ أعلاه.',
    renewNow: 'جدّد الآن',
    manage: 'إدارة الباقة',
    none: 'لا يوجد اشتراك نشط',
    noneDescription: 'اشترك للوصول إلى مزايا المعلنين.',
    browsePlans: 'تصفّح الباقات',
    saved: 'تم تحديث التجديد التلقائي',
    saveError: 'تعذّر تحديث التجديد التلقائي.',
    cycleMonthly: 'شهري',
    cycleYearly: 'سنوي',
    statusValues: { ACTIVE: 'نشط', PAST_DUE: 'متأخر', EXPIRED: 'منتهٍ', CANCELLED: 'ملغى' },
  },

  profile: {
    title: 'بيانات الفوترة',
    description: 'تُستخدم في فواتيرك الضريبية. أضِف الرقم الضريبي والسجل التجاري للحصول على فاتورة ضريبية للأعمال (B2B).',
    legalName: 'الاسم القانوني / المعروض',
    buyerType: 'نوع الحساب',
    individual: 'فرد',
    company: 'منشأة',
    vatNumber: 'الرقم الضريبي',
    crNumber: 'السجل التجاري',
    address: 'عنوان الفوترة',
    billingEmail: 'بريد الفوترة',
    save: 'حفظ البيانات',
    saved: 'تم حفظ بيانات الفوترة',
    saveError: 'تعذّر حفظ بيانات الفوترة.',
    b2bNote: 'إضافة رقم ضريبي تحوّل فواتيرك إلى فواتير ضريبية قياسية (للأعمال).',
    optional: 'اختياري',
  },
};

export default billing;
